import _ from 'lodash'
import React from 'react'

import {
  AddressInput,
  IAddressInputProps,
} from 'browser/components/atomic-elements/atoms/input/address-input/address-input'
import {
  IInputSheetProps,
  InputSheetFactory,
} from 'browser/components/atomic-elements/higher-order-components/input-sheet-factory'

export const AddressInputSheet = InputSheetFactory<IAddressInputProps>(
  AddressInput,
  // No default props needed
  {},
  // Need to override these props in the sheet
  {
    hasLabels: true,
    showEditableFields: true,
  },
)
